// Kept apart from mapUtils.js on purpose: that module imports Leaflet at its
// top level, so importing this one function from there put the whole map
// library on the critical path of every project page.

/**
 * Basic HTML sanitizer for API content
 * Strips potentially dangerous elements and attributes to prevent XSS
 * @param {string} html - The HTML string to sanitize
 * @returns {string} - Sanitized HTML string safe for dangerouslySetInnerHTML
 */
export const sanitizeHTML = (html) => {
    if (!html || typeof html !== 'string') {
        return '';
    }

    // Create a temporary DOM element to parse HTML
    const temp = document.createElement('div');
    temp.innerHTML = html;

    // Remove script tags
    const scripts = temp.querySelectorAll('script');
    scripts.forEach(s => s.remove());

    // Remove all on* event handlers and javascript: hrefs
    const allElements = temp.querySelectorAll('*');
    allElements.forEach(el => {
        Array.from(el.attributes).forEach(attr => {
            if (attr.name.startsWith('on') ||
                (attr.name === 'href' && attr.value.toLowerCase().startsWith('javascript:'))) {
                el.removeAttribute(attr.name);
            }
        });
    });

    // Remove dangerous tags
    const dangerous = temp.querySelectorAll('iframe, object, embed, form, input, button, style, link, meta, base');
    dangerous.forEach(el => el.remove());

    return temp.innerHTML;
};
